/** 埋点事件名：统一「skills_hub + expose / click」两种，参数用 page_name/component_name/click_point 区分站点与点位，uin 标记用户。 */
export const ANALYTICS_EVENTS = {
  /** 曝光（弹窗打开上报一次） */
  apiKeyExpose: 'skills_hub_expose',
  /** 点击（入口 / 复制，用 click_point 区分） */
  apiKeyClick: 'skills_hub_click',
} as const

/** 站点（page_name） */
export const ANALYTICS_PAGE = {
  /** 落地页（AISkillsLanding 及其子组件所在站点） */
  landing: 'landing',
} as const

/** 点击点位 */
export const ANALYTICS_CLICK_POINT = {
  /** 弹窗入口（header 用户下拉「API Key」） */
  entry: 'entry',
  /** 复制按钮 */
  copy: 'copy',
} as const